import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  MapPin,
  Fuel,
  Gauge,
  ArrowLeft,
  Truck,
} from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

const DashboardConductor = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const acciones = [
    {
      title: 'Rutas',
      description: 'Gestionar entregas y recolecciones del día',
      icon: MapPin,
      color: 'bg-blue-500',
      hoverColor: 'hover:bg-blue-50',
      borderColor: 'border-blue-200',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      path: '/rutas',
    },
    {
      title: 'Registro Kilometraje',
      description: 'Registrar km inicial y final del vehículo',
      icon: Gauge,
      color: 'bg-emerald-500',
      hoverColor: 'hover:bg-emerald-50',
      borderColor: 'border-emerald-200',
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600',
      path: '/conductor/kilometraje',
    },
    {
      title: 'Registro Gasolina',
      description: 'Registrar tanqueos y consumo de combustible',
      icon: Fuel,
      color: 'bg-amber-500',
      hoverColor: 'hover:bg-amber-50',
      borderColor: 'border-amber-200',
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      path: '/conductor/gasolina',
    },
  ];

  return (
    <div className="container mx-auto p-4 sm:p-6 max-w-4xl">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center">
            <Truck className="h-7 w-7 text-blue-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Hola, {user?.nombre || 'Conductor'}
            </h1>
            <p className="text-sm text-gray-500">
              Panel de conductor — selecciona una acción
            </p>
          </div>
        </div>

        {/* Grid de acciones */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {acciones.map((accion, index) => {
            const Icon = accion.icon;
            return (
              <motion.div
                key={accion.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <Card
                  className={`cursor-pointer transition-all duration-200 ${accion.hoverColor} border-2 ${accion.borderColor} hover:shadow-lg hover:-translate-y-1`}
                  onClick={() => navigate(accion.path)}
                >
                  <CardContent className="p-6 flex flex-col items-center text-center">
                    <div className={`w-16 h-16 ${accion.iconBg} rounded-2xl flex items-center justify-center mb-4`}>
                      <Icon className={`h-8 w-8 ${accion.iconColor}`} />
                    </div>
                    <h3 className="font-bold text-lg text-gray-900 mb-1">
                      {accion.title}
                    </h3>
                    <p className="text-sm text-gray-500">
                      {accion.description}
                    </p>
                  </CardContent>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
};

export default DashboardConductor;
